// extracted by mini-css-extract-plugin
module.exports = {"favorite":"fI","favoriteCount":"fJ"};